<template>
    <section class="grid xs-grid-cols-1" id="locationPanel">
        <template v-if="dpp.geo.lat && dpp.geo.lng">
            <h2 class="f4 text-bold singleline">Around the neighborhood </h2>
            <div v-if="glb?.geo?.neighborhoodPagePath">
                <a :href="glb.appUrl + glb?.geo?.neighborhoodPagePath" class="link f7" comp="neighborhoods_dpp" :data-link-name="`${glb?.geo?.neighborhood}, ${glb?.geo?.city}, ${glb?.geo?.state}`">Learn more about the {{ glb?.geo?.neighborhood ?? '' }} neighborhood</a>
            </div>
            <propertyPoiRecord></propertyPoiRecord>
            <div id="propertyMapView" v-if="componentMounted">
                <div class="dpp-map" @click="popMapView" role="button">
                    <span class="circle dark">
                        <i class="icon-expand"></i>
                    </span>
                    <mvtMapStatic v-if="marketArr" class="img" :height="300" :lat="dpp.geo.lat" :lng="dpp.geo.lng"  zoom="15" type="roadmap" :address="dpp.geo.formatAddress" :markers="marketArr">
                    </mvtMapStatic>
                </div>
            </div>
            <div v-else class="skeleton" style="height: 300px;"></div>
            <div class="list-card" style="margin: 0 12px;" v-if="(getNearbySchools && getNearbySchools.length) || (getFilteredPois && getFilteredPois.length)">
                <mvtShifter class="width-auto">
                    <template v-if="getNearbySchools && getNearbySchools.length">
                        <button type="button" @click="select(0)" class="btn secondary small" :class="{'active': index===0}">Schools</button>
                    </template>
                    <template v-for="(item,i) in getFilteredPois" :key="item.key">
                        <button type="button" @click="select(i+1)"  class="btn secondary small" :class="{'active': index===i+1}">{{item.poiTypeName}}</button>
                    </template>
                </mvtShifter>
            </div>
            <div class="grid xs-grid-cols-1" v-if="selectSchool && selectSchool.length">
                <mvtCardSchool  v-for="item in selectSchool"  :data="item" :key="item.id"></mvtCardSchool>
                <button type="button" class="link text-right" v-if="selectSchool.length > 4" @click="popMapView">Show All Schools</button>
                <div class="f7">Source: <a class="link" href="http://greatschools.org/" rel="nofollow" target="_blank">GreatSchools.org</a> © {{new Date().getFullYear()}}. All rights reserved.</div>
            </div>
            <div class="grid xs-grid-cols-1 f6" v-else-if="selectPoi && selectPoi.minlist && selectPoi.minlist.length">
                <button type="button" v-for="item in selectPoi.minlist" class="outline inline corner bg-default flex left" @click="popMapView({activeMarker: {type: selectPoi.type,lat:item.lat, lng:item.lon}})">
                    <i class="poi active circle tiny disabled" :class="selectPoi.icon"></i> <span class="singleline">{{item.name}}</span> <span v-if="item.distance" class="m-l-auto noshrink">{{item.distance.toFixed(2)}} mi</span>
                </button>
                <button type="button" class="link text-right" v-if="selectPoi.list.length > 4" @click="popMapView">Show All {{ selectPoi.poiTypeName }}</button>
            </div>
            <dppCtaCard  v-else-if="dpp.isActive" :dppCtaInfo="dppCardOpt"/>
        </template>
        <mvtBreadcrumb :geo="dpp.geo" :isActive="dpp.isActive"></mvtBreadcrumb>
    </section>
</template>
<script src="./property-staticmap.js"></script>